/**
 * "Fill to end": how many drops one click adds (moved out of slot-times.ts,
 * 15/10/2026, for the size cap). The minutes are the country's — the
 * caller passes the timing mirror's local start and end.
 * For Media Devoted | Created By Ciro Autiero
 */

/** One Fill click never adds more rows than this — a 1-min-interval typo
 *  must not explode the table; clicking again continues the fill. */
export const FILL_SLOT_CAP = 50;

export interface FillableSlotsInput {
  startMin: number | null;
  intervalMin: number;
  /** Last minute a drop may land on (container endAtMin, else window end). */
  boundaryMin: number;
  enabledCount: number;
}

/** How many slots "Fill to end" would add: interval steps from the start
 *  through the boundary (inclusive), minus the enabled slots already
 *  occupying the leading positions. Capped at FILL_SLOT_CAP per click. */
export function fillableSlotCount(input: FillableSlotsInput): number {
  const { startMin, intervalMin, boundaryMin, enabledCount } = input;
  if (startMin === null || intervalMin <= 0 || boundaryMin < startMin)
    return 0;
  const capacity = Math.floor((boundaryMin - startMin) / intervalMin) + 1;
  return Math.min(Math.max(0, capacity - enabledCount), FILL_SLOT_CAP);
}
